import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import Logo from "@/components/Logo";
import { ArrowRight } from "@phosphor-icons/react";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            const u = await login(email, password);
            const dest = loc.state?.from || (u.role === "admin" ? "/admin" : "/dashboard");
            nav(dest, { replace: true });
        } catch (e) {
            setErr(e.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen grid md:grid-cols-2" data-testid="login-page">
            <div className="hidden md:flex bg-zinc-950 text-white p-12 flex-col justify-between relative overflow-hidden">
                <Link to="/"><Logo variant="light" /></Link>
                <div className="relative z-10">
                    <div className="uppercase-tag text-zinc-500 mb-4">01 · Bienvenue</div>
                    <h1 className="font-display font-black tracking-tighter text-5xl leading-[1]">
                        Zéro déchet.<br />Zéro souci.<br /><span className="text-fzblue">Zéro effort.</span>
                    </h1>
                    <p className="mt-6 text-zinc-400 max-w-md">
                        Reconnectez-vous à votre frigo intelligent. Vos aliments, vos recettes IA, votre impact.
                    </p>
                </div>
                <div className="text-xs text-zinc-500 font-mono">monfrigozero.app</div>
                <div className="absolute inset-0 grid-lines opacity-10 pointer-events-none" />
            </div>
            <div className="flex items-center justify-center p-8 md:p-16">
                <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
                    <div className="uppercase-tag mb-3">Connexion</div>
                    <h2 className="font-display font-black tracking-tighter text-3xl">Ravi de vous revoir.</h2>
                    <p className="mt-2 text-sm text-zinc-500">Pas encore de compte ? <Link to="/register" className="text-fzblue underline">Créer un compte</Link></p>

                    <div className="mt-8 space-y-4">
                        <div>
                            <label className="uppercase-tag block mb-2">Email</label>
                            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                                className="w-full border border-zinc-300 px-4 py-3 focus:outline-none focus:border-fzblue" placeholder="vous@exemple.fr" />
                        </div>
                        <div>
                            <label className="uppercase-tag block mb-2">Mot de passe</label>
                            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                                className="w-full border border-zinc-300 px-4 py-3 focus:outline-none focus:border-fzblue" placeholder="••••••••" />
                        </div>
                        {err && <div data-testid="login-error" className="text-fzred text-sm">{err}</div>}
                        <button data-testid="login-submit" type="submit" disabled={loading} className="btn-primary w-full disabled:opacity-60">
                            {loading ? "Connexion..." : "Se connecter"} <ArrowRight size={16} />
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
